import { render, staticRenderFns } from "./PersonSelectionTable.vue?vue&type=template&id=0d4df5f4&"
import script from "./PersonSelectionTable.vue?vue&type=script&lang=ts&"
export * from "./PersonSelectionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports